export const supportEmail = process.env.VITE_SUPPORT_EMAIL;

export const DEMO_TENANTS = [
  "tenant:demo",
  "tenant:demo-au",
  "tenant:demo-planning",
  "tenant:demo-planning-au",
];

// matches the react-hook-form-mui required message
// only needed when using raw MUI fields
export const FIELD_REQUIRED_MESSAGE = "This field is required";

export const MAIN_CONTENT_MAX_WIDTH = 852;

export const APP_BAR_HEIGHT = 56;

export const PAGE_HEADER_HEIGHT = 70;

export const ATTACHMENT_MAX_SIZE_MB = 3;

export const BYTES_IN_KB = 1024;

export const BYTES_IN_MB = BYTES_IN_KB * BYTES_IN_KB;
